<div class="headline-6 px-3 my-3">Paid</div>
@if(!paidDonations || paidDonations.length === 0){
    <div class="p-3 text-center">No paid donations yet.</div>
} @else{
    <div class="table--paybee" >
        <table id="auctionPaidDatatable" class="table" cellspacing="0" style="width: 100%; background-color: white;"
            datatable #auctionPaidDatatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead class="thead-light">
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th class="text-nowrap">First Name</th>
                <th class="text-nowrap">Last Name</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Option </th>
                <th>Delivered</th>
                <th>Amount</th>
                <th>Value</th>
                <th>Tax</th>
                <th>Date </th>
                <th>Method</th>
                <th>
                    <div class="d-flex align-items-center">
                        Info
                        <span data-toggle='popover-hover-table'
                            data-trigger='hover'
                            data-placement='right'
                            title='{{auction?.additionalInfoDesc}}'
                            class='ml-1'>
                            <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                        </span>
                    </div>
                </th>
                <th class="text-nowrap">
                    <div class="d-flex align-items-center text-nowrap">
                        Info Selected
                        <span data-toggle='popover-hover-table'
                            data-trigger='hover'
                            data-placement='right'
                            title='{{auction?.additionalInfoSelectDesc}}'
                            class='ml-1'>
                            <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                        </span>
                    </div>
                </th>
            </tr>
            </thead>
        </table>
    </div>
}

